"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenuePeekDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const User_dto_1 = require("./users/User.dto");
class VenuePeekDto {}
exports.VenuePeekDto = VenuePeekDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", User_dto_1.UserDto)], VenuePeekDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenuePeekDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenuePeekDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.PeekType
}), __metadata("design:type", String)], VenuePeekDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", String)], VenuePeekDto.prototype, "createdAt", void 0);
//# sourceMappingURL=VenuePeek.dto.js.map